export default __webpack_public_path__ + "static/media/Juan Frias.7965b2bf.jpg";